import React, { useState, useCallback, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import logo from '../assets/images/pilari_dark.png';
import imageIlmu from '../assets/images/hero-bg-light.webp';
import imageAksi from '../assets/images/hero-bg-light.webp';
import imagePandu from '../assets/images/hero-bg-light.webp';
import imageReward from '../assets/images/hero-bg-light.webp';

const slides = [
  {
    title: 'Selamat Datang di Roadmap Pilari',
    content: 'Aplikasi Pilah Sampah Mandiri untuk Masa Depan yang Lebih Bersih',
    centeredLogo: true,
    background: 'bg-gradient-to-br from-white via-green-50 to-green-100'
  },
  {
    title: 'Roadmap Pilari',
    content: '4 Fase Pengembangan:\n1. Edukasi & Aksi Nyata\n2. Deteksi & Layanan Lapangan\n3. Interaksi & Dukungan\n4. Ekspansi & Sponsorship',
    background: 'bg-gradient-to-br from-white to-gray-50'
  },
  {
    title: 'Fokus Hari Ini: Fase 1',
    content: 'Kami akan mendemokan fitur utama:\n- Pilah Ilmu\n- Pilah Aksi\n- Pilah Pandu\n- Pilah Reward & Jejak',
    background: 'bg-white'
  },
  {
    title: 'Pilah Ilmu',
    content: 'Belajar tentang Zero Waste melalui kursus dan kuis interaktif.',
    image: imageIlmu,
    background: 'bg-gradient-to-r from-white to-emerald-50'
  },
  {
    title: 'Pilah Aksi',
    content: 'Ikuti tantangan aksi nyata dan laporkan kegiatan Anda.',
    image: imageAksi,
    background: 'bg-gradient-to-r from-white to-lime-50'
  },
  {
    title: 'Pilah Pandu',
    content: 'Checklist dan panduan praktis untuk memilah sampah dari rumah.',
    image: imagePandu,
    background: 'bg-gradient-to-r from-white to-green-50'
  },
  {
    title: 'Pilah Reward & Jejak',
    content: 'Dapatkan poin dan badge, lacak progres pribadi Anda.',
    image: imageReward,
    background: 'bg-gradient-to-r from-white to-yellow-50'
  },
  {
    title: 'Yang Akan Datang',
    content: 'Fase 2: Scanner AI & Layanan\nFase 3: Komunitas & Dukungan\nFase 4: CSR, Instansi, White Label',
    background: 'bg-gradient-to-t from-white to-slate-50'
  },
  {
    title: 'Kolaborasi & Dukungan',
    content: 'Ayo dukung Pilari!\nKomunitas | Pemerintah | Mitra CSR',
    background: 'bg-white'
  },
  {
    title: 'Terima Kasih',
    content: 'Sampai jumpa di Pilari 💚',
    centeredLogo: true,
    background: 'bg-gradient-to-tr from-green-50 to-white'
  }
];

const RoadmapPitchPage = () => {
  const [index, setIndex] = useState(0);

  const handleNext = useCallback(() => {
    if (index < slides.length - 1) setIndex(index + 1);
  }, [index]);

  const handlePrev = useCallback(() => {
    if (index > 0) setIndex(index - 1);
  }, [index]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'ArrowRight') handleNext();
    if (e.key === 'ArrowLeft') handlePrev();
  }, [handleNext, handlePrev]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  const slide = slides[index];

  return (
    <div className={`w-screen h-screen overflow-hidden flex flex-col items-center justify-center text-center p-6 transition-all ease-in-out ${slide.background} relative`}>
      {!slide.centeredLogo && (
        <img src={logo} alt="Pilari Logo" className="absolute top-6 left-6 w-20 md:w-28 opacity-90" />
      )}

      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -30 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col items-center justify-center"
        >
          {slide.centeredLogo && (
            <img src={logo} alt="Pilari Logo" className="w-32 md:w-40 mb-8 mx-auto" />
          )}

          <h1 className="text-3xl md:text-5xl font-bold mb-4 text-gray-900 dark:text-white">
            {slide.title}
          </h1>

          <p className="text-lg md:text-2xl whitespace-pre-line max-w-3xl mx-auto text-gray-800 dark:text-gray-200 mb-6">
            {slide.content}
          </p>

          {slide.image && (
            <img
              src={slide.image}
              alt="Visual"
              className="max-h-72 md:max-h-96 object-contain rounded-xl shadow-xl"
            />
          )}
        </motion.div>
      </AnimatePresence>

      <div className="absolute bottom-10 flex gap-4">
        <button
          onClick={handlePrev}
          disabled={index === 0}
          className="p-3 rounded-full bg-white/80 dark:bg-black/30 shadow-md hover:bg-white dark:hover:bg-black"
        >
          <ArrowLeft />
        </button>
        <button
          onClick={handleNext}
          disabled={index === slides.length - 1}
          className="p-3 rounded-full bg-white/80 dark:bg-black/30 shadow-md hover:bg-white dark:hover:bg-black"
        >
          <ArrowRight />
        </button>
      </div>
    </div>
  );
};

export default RoadmapPitchPage;